import { RefundMode, useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useGetPaymentTerminalIdForRefundsSuspense = (refundMode: RefundMode) =>
    useRepositorySuspenseQuery(
        'paymentTerminals',
        'getAll',
        {},
        {
            select: (result) => {
                const stripeTerminals = result.filter((t) => t.isStripeTerminal);
                const singleStripeTerminalId = stripeTerminals.length === 1 ? stripeTerminals[0].id : undefined;
                return refundMode === RefundMode.InPerson ? singleStripeTerminalId : undefined;
            },
        }
    );
